
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11461',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11461",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.202",
  "data-fetching-client": "static-1.9445",
  "foundations-components": "static-1.7461",
  "foundations-components-legacy": "static-1.486",
  "foundations-theming": "static-1.4176",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7773",
  "hub-http-shared-msw-handlers": "static-1.9401",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-runner": "static-1.6241",
  "marketplace-storefront-base": "static-1.11521",
  "quartz": "static-1.6683",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16408",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2631",
  "reporting-testing-lib": "static-1.8315",
  "settings-ui-lib": "static-1.12288",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6667",
  "ui-addon-i18n": "static-1.10899",
  "ui-addon-react-router-dom": "static-1.9316",
  "unified-auth": "static-1.161",
  "unified-auth-core-lib": "static-1.442",
  "usage-tracker": "static-1.7101",
  "usage-tracker-core": "static-1.6951",
  "customer-data-property-utils": "static-1.7839",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15314",
  "marketplace-ui-common": "static-1.18854",
  "property-management-iframe": "static-1.12185",
  "quartz-config": "static-1.461",
  "quartz-core": "static-1.5902",
  "quartz-routing": "static-1.113",
  "quick-fetch": "static-1.3703",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4399",
  "ts-schema": "static-1.3874",
  "ui-universal-auth": "static-1.8647",
  "UIComponents": "static-3.8134",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2960",
  "quartz-webpack": "static-1.2907",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3730",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4600",
  "foundations-theming-specialty": "static-1.1892",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9196",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5144",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1102",
  "ui-fonts": "static-1.449",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-theming": "static-1.2659",
  "foundations-theming-base": "static-1.3161",
  "stylex": "static-1.27",
  "HeadJS": "static-2.703",
  "hs-test-utils-bend-plugin": "static-1.2884",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4098",
  "ai-components-ui-library": "static-1.8265",
  "ai-rendering-library": "static-1.9206",
  "chirp-fetch": "static-1.1651",
  "connections-embed-lib": "static-1.580",
  "copilot-toolkit": "static-1.10443",
  "laboratory-lib": "static-3.6930",
  "marketplace-embed": "static-1.21395",
  "marketplace-ui-details": "static-1.8750",
  "marketplace-ui-reviews": "static-1.18810",
  "marketplace-ui-tracking": "static-1.13025",
  "sanitize-text": "static-1.7908",
  "ui-addon-video-player": "static-1.8463",
  "usage-tracker-multi": "static-1.5515",
  "usage-tracker-session-replay": "static-1.4787",
  "wootric-nps": "static-1.6749",
  "apollo-link-hub-http": "static-2.4417",
  "immer": "static-1.33",
  "immerable": "static-1.3922",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2376",
  "reporting-data": "static-1.66382",
  "cssUtils": "static-1.723",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11495",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9980",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10140",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7091",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17387",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4291",
  "foundations-components-test-utils": "static-1.4944",
  "quartz-i18n": "static-1.358",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3499",
  "customer-data-objects": "static-1.7412",
  "property-translator": "static-1.5181",
  "frontend-preferences-client": "static-1.7691",
  "hs-promise-utils": "static-1.5359",
  "hubspot-apollo-client": "static-1.4647",
  "integrations-error-boundary-lib": "static-1.12729",
  "integrations-tracking-lib": "static-1.5351",
  "native-integrations-shared-strings": "static-1.7556",
  "reselect": "static-2.16",
  "sanitize": "static-1.4242",
  "superstore": "static-1.4539",
  "ui-shepherd-react": "static-3.9913",
  "ai-settings-ui-library": "static-1.7352",
  "hub-http-janus": "static-1.786",
  "hubspotter-http": "static-1.4448",
  "immutable-less": "static-1.4421",
  "marketplace-ui-client-types": "static-1.16261",
  "nav-meta": "static-1.28803",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10004",
  "ui-addon-upgrades": "static-9.17602",
  "inbound-db-properties-service-client": "static-1.3646",
  "property-management-common": "static-1.4472",
  "ui-addon-iframeable": "static-1.8809",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.358",
  "quartz-head": "static-1.348",
  "quartz-test": "static-1.358",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2903",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20186",
  "ContentUtils": "static-1.67528",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2253",
  "customer-data-filters-ui": "static-1.38769",
  "customer-data-objects-ui-components": "static-1.12771",
  "customer-data-reference-ui-components": "static-1.12910",
  "embedded-academy-lib": "static-1.13391",
  "ExportDialog": "static-6.10156",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40569",
  "reporting-snowflake": "static-1.55000",
  "reporting-ui-components": "static-2.63653",
  "reporting-visualizations": "static-1.58458",
  "ui-addon-teams": "static-1.21196",
  "magpie-lib": "static-1.5362",
  "magpie-types": "static-1.4822",
  "simple-logging-lib": "static-1.2818",
  "navigation-components": "static-1.17166",
  "ai-studio-lib": "static-1.10908",
  "developer-experience-shared-components": "static-1.10235",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7752",
  "ui-tool-access": "static-1.9911",
  "usage-based-billing-components-lib": "static-1.7926",
  "usage-tracker-anonymous": "static-1.5518",
  "usage-tracker-public": "static-1.6912",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3475",
  "reference-resolvers": "static-1.7927",
  "ui-extensibility-client-types": "static-1.3716",
  "hubspot-apollo-cache": "static-1.106",
  "universal-page-editor-lib": "static-1.2763",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2096",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4838",
  "purchase-motions-components": "static-1.5438",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4275",
  "batch-promise": "static-1.1318",
  "crm-component-utils": "static-1.38405",
  "crm-properties-common-lib": "static-1.5639",
  "framework-data-schema-resolvers": "static-1.6637",
  "reference-resolvers-lite": "static-1.7857",
  "navigation-messaging": "static-1.6493",
  "hubspotter-http-shared-msw-handlers": "static-1.9399",
  "cms-field-types": "static-1.4574",
  "content-icons-ui": "static-1.2144",
  "conversations-skeleton-state": "static-1.7017",
  "crm-message-bus": "static-1.42254",
  "customer-data-filters-ui-msw-helpers": "static-1.21203",
  "customer-data-ui-utilities": "static-1.9592",
  "FormUrlGenerator": "static-2.4498",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6542",
  "multi-account-reference-resolvers": "static-1.736",
  "onboarding-tours": "static-1.16214",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12963",
  "academy-common-lib": "static-1.12851",
  "content-assistance-lib": "static-1.7401",
  "dashboard-lib": "static-1.80483",
  "file-manager-components": "static-1.22795",
  "getting-started-shared-tasks": "static-1.17791",
  "hubspot-prosemirror": "static-1.17514",
  "hubspot-prosemirror-plugins": "static-1.17506",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19419",
  "share-with-third-party-component-lib": "static-1.8458",
  "ui-addon-draggable": "static-3.4533",
  "ui-asset-management-lib": "static-1.10666",
  "ui-business-units-lib": "static-1.8790",
  "user-context": "static-1.4862",
  "growth-payments-core": "static-1.24635",
  "highcharts": "static-8.99",
  "reporting-plugins": "static-1.9940",
  "reporting-reports": "static-1.66060",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.494",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28793",
  "react-codemirror": "static-1.10394",
  "apps-service-types": "static-1.3646",
  "oauth-service-types": "static-1.4008",
  "onboarding-scopes": "static-1.6232",
  "onboarding-tours-client": "static-1.4428",
  "platform-infra-nav-components": "static-1.7463",
  "subscription-experience-data-types": "static-1.14545",
  "crm-record-cards-service-types": "static-1.3422",
  "location-customization-utils-lib": "static-1.8456",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4291",
  "nav-client-types": "static-1.2123",
  "purchase-motions-api": "static-1.5441",
  "signup-constants": "static-1.18326",
  "signup-ui-url-generator": "static-2.7831",
  "trials-service-types": "static-1.3692",
  "card-properties-lib": "static-1.43430",
  "crm-actions": "static-1.6062",
  "crm-cards-data": "static-1.1145",
  "crm-cards-sdk": "static-1.42816",
  "customer-data-properties": "static-1.50694",
  "customer-data-properties-shared-msw-handlers": "static-1.8728",
  "customer-data-tracking": "static-1.6650",
  "conditional-properties-service-client": "static-1.3594",
  "crm-pipelines-api-client-types": "static-1.3935",
  "multi-currency-client-types": "static-1.3488",
  "external-options-client-types": "static-1.3954",
  "react-dnd-compat": "static-1.4391",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2838",
  "growth-onboarding-next-action-utils": "static-1.1262",
  "onboarding-tours-utils": "static-1.280",
  "ui-shepherd-tracker": "static-1.7294",
  "academy-service-client": "static-1.3449",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27860",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8153",
  "video-components-external": "static-1.10480",
  "video-data-lib": "static-1.34138",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8336",
  "payment-link-components": "static-1.22850",
  "ui-addon-emoji-picker": "static-1.9657",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6796",
  "data-token-picker": "static-1.15991",
  "FileManagerLib": "static-1.38435",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5012",
  "getting-started-shared-tasks-store": "static-1.16909",
  "campaign-roi-lib": "static-1.8182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.158",
  "eligibility-engine-service-types": "static-1.2973",
  "crm_data": "static-4.91112",
  "crm-links": "static-1.6022",
  "customer-data-sidebar": "static-2.45328",
  "enrichment-properties-lib": "static-1.14879",
  "crm-fe-perf": "static-1.22675",
  "calling-global-api": "static-1.63546",
  "calling-internal-common": "static-1.31060",
  "calling-lifecycle-internal": "static-1.64928",
  "calling-lifecycle-messages": "static-1.57222",
  "commerce-products-lib": "static-1.8760",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.439",
  "inbounddb-objects-service-types": "static-1.4020",
  "meetings-icalendar-utils-lib": "static-1.402",
  "object-builder-ui-client": "static-1.47865",
  "pipeline-validation-client-types": "static-1.3757",
  "property-value-citations": "static-1.1308",
  "pulse": "static-1.271",
  "smart-property-lib": "static-1.5761",
  "tiered-pricing": "static-1.781",
  "ui-addon-form-validation": "static-1.10762",
  "growth-onboarding-feedback-components": "static-1.6353",
  "content-media-composition-data-lib": "static-1.11336",
  "content-media-compositions": "static-2.15343",
  "media-bridge-lib": "static-1.18513",
  "commerce-tours-lib": "static-1.5669",
  "growth-onboarding-reliability": "static-1.4856",
  "sales-checkout-service-client": "static-1.3445",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21257",
  "sales-email-signature-service-client": "static-1.3612",
  "audio-components": "static-1.5566",
  "FileManagerCore": "static-1.38294",
  "FileManagerImages": "static-1.35946",
  "video-components": "static-1.12483",
  "crm_universal": "static-1.21609",
  "customer-data-email": "static-1.17617",
  "calling-error-reporting": "static-1.31066",
  "card-payment-highlight-lib": "static-1.36413",
  "card-subscription-highlight-lib": "static-1.38769",
  "commerce-billing-lib": "static-1.18409",
  "commerce-contract-lib": "static-1.11042",
  "customer-data-content": "static-1.26819",
  "invoices-highlight-card-lib": "static-1.53903",
  "orders-highlight-card-lib": "static-1.20796",
  "products-highlight-card-lib": "static-1.17044",
  "project-storage": "static-1.4500",
  "quotes-highlight-card-lib": "static-1.71038",
  "breeze-intelligence-kit": "static-1.5274",
  "crm-source-interpretation-lib": "static-1.5099",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9484",
  "policy-lib": "static-1.6552",
  "shared-worker-versioning": "static-1.10805",
  "calling-usage-tracker": "static-1.6306",
  "voice-sms-access-library": "static-1.150",
  "products-iframe-lib": "static-1.7229",
  "products-ui-components-shared-msw-handlers": "static-1.9783",
  "directed-graph": "static-1.705",
  "event-emitter": "static-1.715",
  "react-tinymce": "static-1.54535",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9547",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53661",
  "tinymce-plugins": "static-1.56775",
  "tinymce-themes": "static-1.55631",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4302",
  "video-embed": "static-1.34972",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7639",
  "ui-gdpr-components": "static-1.10114",
  "commerce-shared-components-lib": "static-1.17835",
  "commerce-subscription-lib": "static-1.36346",
  "commerce-tools-ui-lib": "static-1.9713",
  "utility-belt": "static-1.2310",
  "payments-enrollment-embed-lib": "static-1.21872",
  "products-ui-components": "static-1.39279",
  "quotes-client-types": "static-1.37126",
  "quotes-ui-lib": "static-1.79757",
  "SalesContentIndexUI": "static-3.8853",
  "accounting-integrations-ui-components": "static-1.6677",
  "invoices-ui-lib": "static-1.53919",
  "commerce-products-api": "static-1.1910",
  "SafeStorage": "static-1.4172",
  "invoices-iframe-lib": "static-1.55977",
  "quotes-modal-lib": "static-1.101714",
  "calling-orchestration-schema": "static-1.34927",
  "sales-views-client-types": "static-1.4059",
  "hub-http-contrib": "static-1.2812",
  "interframe": "static-3.4559",
  "tinymce-data": "static-1.39746",
  "ui-addon-sales-email": "static-1.4981",
  "layout-dnd-components": "static-1.11975",
  "layout-dnd-utils": "static-1.10950",
  "ui-brand-identity-lib": "static-1.13714",
  "NamespacedHubStyle": "static-2.8867",
  "outpost": "static-1.3975",
  "sequences-client-types-lib": "static-1.7496",
  "customer-data-associations": "static-1.7104",
  "framework-data-table": "static-2.11339",
  "customer-data-rte": "static-1.32371",
  "cv-backend-services": "static-1.1488",
  "growth-onboarding-empty-states": "static-1.5316",
  "InboxConnectUtils": "static-4.14142",
  "payments-post-enroll-local-storage-lib": "static-1.4880",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7081",
  "commerce-permissions": "static-1.520",
  "commerce-tax-lib": "static-1.276",
  "property-description-translator": "static-1.3627",
  "FireAlarmUi": "static-1.4298",
  "sales-templates-service-types-lib": "static-1.3964",
  "commerce-analytics-service-client": "static-1.3433",
  "totals-ui-components": "static-1.22920",
  "ContentData": "static-1.67603",
  "layout-data-lib": "static-1.9275",
  "deal-intel-decorators": "static-1.1129",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27639",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3608",
  "advanced-menus-core": "static-1.14769",
  "advanced-menus-lib": "static-1.11751",
  "ui-memberships-settings-lib": "static-1.33344",
  "deal-intel-utils": "static-1.1133",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14768",
  "simple-menus-lib": "static-1.16285"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11461",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.202",
  "data-fetching-client": "/data-fetching-client/static-1.9445",
  "foundations-components": "/foundations-components/static-1.7461",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.486",
  "foundations-theming": "/foundations-theming/static-1.4176",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7773",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9401",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-runner": "/jasmine-runner/static-1.6241",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11521",
  "quartz": "/quartz/static-1.6683",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16408",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2631",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8315",
  "settings-ui-lib": "/settings-ui-lib/static-1.12288",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6667",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10899",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9316",
  "unified-auth": "/unified-auth/static-1.161",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.442",
  "usage-tracker": "/usage-tracker/static-1.7101",
  "usage-tracker-core": "/usage-tracker-core/static-1.6951",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7839",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15314",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18854",
  "property-management-iframe": "/property-management-iframe/static-1.12185",
  "quartz-config": "/quartz-config/static-1.461",
  "quartz-core": "/quartz-core/static-1.5902",
  "quartz-routing": "/quartz-routing/static-1.113",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4399",
  "ts-schema": "/ts-schema/static-1.3874",
  "ui-universal-auth": "/ui-universal-auth/static-1.8647",
  "UIComponents": "/UIComponents/static-3.8134",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2960",
  "quartz-webpack": "/quartz-webpack/static-1.2907",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3730",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4600",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1892",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9196",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5144",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1102",
  "ui-fonts": "/ui-fonts/static-1.449",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2659",
  "foundations-theming-base": "/foundations-theming-base/static-1.3161",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.703",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4098",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8265",
  "ai-rendering-library": "/ai-rendering-library/static-1.9206",
  "chirp-fetch": "/chirp-fetch/static-1.1651",
  "connections-embed-lib": "/connections-embed-lib/static-1.580",
  "copilot-toolkit": "/copilot-toolkit/static-1.10443",
  "laboratory-lib": "/laboratory-lib/static-3.6930",
  "marketplace-embed": "/marketplace-embed/static-1.21395",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8750",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18810",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13025",
  "sanitize-text": "/sanitize-text/static-1.7908",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8463",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5515",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4787",
  "wootric-nps": "/wootric-nps/static-1.6749",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4417",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3922",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2376",
  "reporting-data": "/reporting-data/static-1.66382",
  "cssUtils": "/cssUtils/static-1.723",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11495",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9980",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10140",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7091",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17387",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4291",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4944",
  "quartz-i18n": "/quartz-i18n/static-1.358",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3499",
  "customer-data-objects": "/customer-data-objects/static-1.7412",
  "property-translator": "/property-translator/static-1.5181",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "hs-promise-utils": "/hs-promise-utils/static-1.5359",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4647",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12729",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5351",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7556",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4242",
  "superstore": "/superstore/static-1.4539",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9913",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7352",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "hubspotter-http": "/hubspotter-http/static-1.4448",
  "immutable-less": "/immutable-less/static-1.4421",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16261",
  "nav-meta": "/nav-meta/static-1.28803",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10004",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17602",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
  "property-management-common": "/property-management-common/static-1.4472",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8809",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.358",
  "quartz-head": "/quartz-head/static-1.348",
  "quartz-test": "/quartz-test/static-1.358",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20186",
  "ContentUtils": "/ContentUtils/static-1.67528",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2253",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38769",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12771",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12910",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13391",
  "ExportDialog": "/ExportDialog/static-6.10156",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40569",
  "reporting-snowflake": "/reporting-snowflake/static-1.55000",
  "reporting-ui-components": "/reporting-ui-components/static-2.63653",
  "reporting-visualizations": "/reporting-visualizations/static-1.58458",
  "ui-addon-teams": "/ui-addon-teams/static-1.21196",
  "magpie-lib": "/magpie-lib/static-1.5362",
  "magpie-types": "/magpie-types/static-1.4822",
  "simple-logging-lib": "/simple-logging-lib/static-1.2818",
  "navigation-components": "/navigation-components/static-1.17166",
  "ai-studio-lib": "/ai-studio-lib/static-1.10908",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10235",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7752",
  "ui-tool-access": "/ui-tool-access/static-1.9911",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7926",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5518",
  "usage-tracker-public": "/usage-tracker-public/static-1.6912",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3475",
  "reference-resolvers": "/reference-resolvers/static-1.7927",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3716",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.106",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2096",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4838",
  "purchase-motions-components": "/purchase-motions-components/static-1.5438",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4275",
  "batch-promise": "/batch-promise/static-1.1318",
  "crm-component-utils": "/crm-component-utils/static-1.38405",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5639",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6637",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7857",
  "navigation-messaging": "/navigation-messaging/static-1.6493",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9399",
  "cms-field-types": "/cms-field-types/static-1.4574",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7017",
  "crm-message-bus": "/crm-message-bus/static-1.42254",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21203",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9592",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4498",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6542",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.736",
  "onboarding-tours": "/onboarding-tours/static-1.16214",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12963",
  "academy-common-lib": "/academy-common-lib/static-1.12851",
  "content-assistance-lib": "/content-assistance-lib/static-1.7401",
  "dashboard-lib": "/dashboard-lib/static-1.80483",
  "file-manager-components": "/file-manager-components/static-1.22795",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17791",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17514",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17506",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19419",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8458",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4533",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10666",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8790",
  "user-context": "/user-context/static-1.4862",
  "growth-payments-core": "/growth-payments-core/static-1.24635",
  "highcharts": "/highcharts/static-8.99",
  "reporting-plugins": "/reporting-plugins/static-1.9940",
  "reporting-reports": "/reporting-reports/static-1.66060",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.494",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28793",
  "react-codemirror": "/react-codemirror/static-1.10394",
  "apps-service-types": "/apps-service-types/static-1.3646",
  "oauth-service-types": "/oauth-service-types/static-1.4008",
  "onboarding-scopes": "/onboarding-scopes/static-1.6232",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4428",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7463",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14545",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8456",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4291",
  "nav-client-types": "/nav-client-types/static-1.2123",
  "purchase-motions-api": "/purchase-motions-api/static-1.5441",
  "signup-constants": "/signup-constants/static-1.18326",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7831",
  "trials-service-types": "/trials-service-types/static-1.3692",
  "card-properties-lib": "/card-properties-lib/static-1.43430",
  "crm-actions": "/crm-actions/static-1.6062",
  "crm-cards-data": "/crm-cards-data/static-1.1145",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42816",
  "customer-data-properties": "/customer-data-properties/static-1.50694",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8728",
  "customer-data-tracking": "/customer-data-tracking/static-1.6650",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
  "external-options-client-types": "/external-options-client-types/static-1.3954",
  "react-dnd-compat": "/react-dnd-compat/static-1.4391",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2838",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1262",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.280",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7294",
  "academy-service-client": "/academy-service-client/static-1.3449",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27860",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8153",
  "video-components-external": "/video-components-external/static-1.10480",
  "video-data-lib": "/video-data-lib/static-1.34138",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8336",
  "payment-link-components": "/payment-link-components/static-1.22850",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9657",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6796",
  "data-token-picker": "/data-token-picker/static-1.15991",
  "FileManagerLib": "/FileManagerLib/static-1.38435",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5012",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16909",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.158",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2973",
  "crm_data": "/crm_data/static-4.91112",
  "crm-links": "/crm-links/static-1.6022",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45328",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14879",
  "crm-fe-perf": "/crm-fe-perf/static-1.22675",
  "calling-global-api": "/calling-global-api/static-1.63546",
  "calling-internal-common": "/calling-internal-common/static-1.31060",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64928",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57222",
  "commerce-products-lib": "/commerce-products-lib/static-1.8760",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.439",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4020",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.402",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47865",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3757",
  "property-value-citations": "/property-value-citations/static-1.1308",
  "pulse": "/pulse/static-1.271",
  "smart-property-lib": "/smart-property-lib/static-1.5761",
  "tiered-pricing": "/tiered-pricing/static-1.781",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10762",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6353",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11336",
  "content-media-compositions": "/content-media-compositions/static-2.15343",
  "media-bridge-lib": "/media-bridge-lib/static-1.18513",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5669",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4856",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3445",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21257",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3612",
  "audio-components": "/audio-components/static-1.5566",
  "FileManagerCore": "/FileManagerCore/static-1.38294",
  "FileManagerImages": "/FileManagerImages/static-1.35946",
  "video-components": "/video-components/static-1.12483",
  "crm_universal": "/crm_universal/static-1.21609",
  "customer-data-email": "/customer-data-email/static-1.17617",
  "calling-error-reporting": "/calling-error-reporting/static-1.31066",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36413",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38769",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18409",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11042",
  "customer-data-content": "/customer-data-content/static-1.26819",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53903",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20796",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17044",
  "project-storage": "/project-storage/static-1.4500",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71038",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5274",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5099",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9484",
  "policy-lib": "/policy-lib/static-1.6552",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10805",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6306",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.150",
  "products-iframe-lib": "/products-iframe-lib/static-1.7229",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9783",
  "directed-graph": "/directed-graph/static-1.705",
  "event-emitter": "/event-emitter/static-1.715",
  "react-tinymce": "/react-tinymce/static-1.54535",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9547",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53661",
  "tinymce-plugins": "/tinymce-plugins/static-1.56775",
  "tinymce-themes": "/tinymce-themes/static-1.55631",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4302",
  "video-embed": "/video-embed/static-1.34972",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7639",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10114",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17835",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36346",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9713",
  "utility-belt": "/utility-belt/static-1.2310",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21872",
  "products-ui-components": "/products-ui-components/static-1.39279",
  "quotes-client-types": "/quotes-client-types/static-1.37126",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79757",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8853",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6677",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53919",
  "commerce-products-api": "/commerce-products-api/static-1.1910",
  "SafeStorage": "/SafeStorage/static-1.4172",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55977",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101714",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34927",
  "sales-views-client-types": "/sales-views-client-types/static-1.4059",
  "hub-http-contrib": "/hub-http-contrib/static-1.2812",
  "interframe": "/interframe/static-3.4559",
  "tinymce-data": "/tinymce-data/static-1.39746",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4981",
  "layout-dnd-components": "/layout-dnd-components/static-1.11975",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10950",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13714",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8867",
  "outpost": "/outpost/static-1.3975",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7496",
  "customer-data-associations": "/customer-data-associations/static-1.7104",
  "framework-data-table": "/framework-data-table/static-2.11339",
  "customer-data-rte": "/customer-data-rte/static-1.32371",
  "cv-backend-services": "/cv-backend-services/static-1.1488",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5316",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14142",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4880",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7081",
  "commerce-permissions": "/commerce-permissions/static-1.520",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.276",
  "property-description-translator": "/property-description-translator/static-1.3627",
  "FireAlarmUi": "/FireAlarmUi/static-1.4298",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3964",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3433",
  "totals-ui-components": "/totals-ui-components/static-1.22920",
  "ContentData": "/ContentData/static-1.67603",
  "layout-data-lib": "/layout-data-lib/static-1.9275",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1129",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27639",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3608",
  "advanced-menus-core": "/advanced-menus-core/static-1.14769",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11751",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33344",
  "deal-intel-utils": "/deal-intel-utils/static-1.1133",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14768",
  "simple-menus-lib": "/simple-menus-lib/static-1.16285"
}
};
